import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { FingerprintService } from './service/fingerprint.service';
import { FingerprintMockService } from './service/fingerprint.mock.service';
import { BiometricLoginActivePipe } from './pipes/biometric-login.active.pipe';
import { TouchID } from '@ionic-native/touch-id/ngx';
import { Keychain } from '@ionic-native/keychain/ngx';
import { FingerprintAIO } from '@ionic-native/fingerprint-aio/ngx';
import { AndroidFingerprintAuth } from '@ionic-native/android-fingerprint-auth/ngx';
import { StorageService } from './service/storage.service';
import { FingerprintAuthConfiguration } from './interfaces';
import { Config } from './tokens';

const defaultConfig: FingerprintAuthConfiguration = {
  debug: false,
  enabled: true
}

export function initStorage(storageService) {
  return () => storageService.init();
}
export const storageProvider = {
  provide: APP_INITIALIZER,
  useFactory: initStorage,
  deps: [StorageService],
  multi: true
};

@NgModule({
  declarations: [
    BiometricLoginActivePipe
  ],
  exports: [
    BiometricLoginActivePipe
  ]
})
export class FingerprintAuthModule {

  static forRoot( options: Partial<FingerprintAuthConfiguration> = {} ): ModuleWithProviders<FingerprintAuthModule> {
    options = Object.assign(defaultConfig, options);
    if (options.enabled) {
      return {
        ngModule: FingerprintAuthModule,
        providers: [
          FingerprintService,
          TouchID,
          Keychain,
          FingerprintAIO,
          AndroidFingerprintAuth,
          StorageService,
          storageProvider,
          { provide: Config, useValue: options }
        ]
      }
    } else {
      // Mock service
      return {
        ngModule: FingerprintAuthModule,
        providers: [
          {
            provide: FingerprintService,
            useClass: FingerprintMockService
          },
          TouchID,
          Keychain,
          FingerprintAIO,
          AndroidFingerprintAuth,
          StorageService,
          storageProvider,
          { provide: Config, useValue: options }
        ]
      };
    }
  }

  static forChild(): ModuleWithProviders<FingerprintAuthModule> {
    return {
      ngModule: FingerprintAuthModule
    }
  }

}
